import React, {Component} from 'react';
import PropTypes from "prop-types";
import {X} from "react-feather";

class  ModalTxt extends Component{

    constructor(props) {
        super(props);
        this.props=props;
        this.txt=props.txt;
        this.cmodal=React.createRef();
        this.refTxt=React.createRef();
        this.Hclose = this.close.bind(this);
    }

    setTxt(txt){
        this.refTxt.current.innerHTML=txt;
    }

    async show(){
        this.cmodal.current.classList.add("show-modal");
    }

    close(){
        this.cmodal.current.classList.remove("show-modal");
    }



    render() {
        return (
            <React.Fragment>
                <div className="cmodal" ref={this.cmodal}>
                    <div className="cmodal-content">
                        <span   className="close-button" onClick={this.Hclose}  >
                            <X />
                        </span>
                        <p className="txt"  ref={this.refTxt} />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

ModalTxt.propTypes = {
    txt:PropTypes.string,
};

ModalTxt.defaultProps = {
    txt:""
};

export default ModalTxt;
